<template>
  <div class="container-fluid">
    <nav class="navbar navbar-light bg-light">
      <a class="navbar-brand" href="/">
        いぎなり東北産 Bot
      </a>
      <div class="right" v-if="user">
        <img :src="user.imageUrl" alt="" />
        <span>{{user.screenName}}</span>
      </div>
    </nav>
    <div class="alert alert-success" v-if="success">
      {{success}}
    </div>
    <div class="alert alert-danger" v-if="error">
      {{error}}
    </div>
    <div>
      <p>いぎなり東北産の楽曲を定期的につぶやくbotです。</p>
      <p>ツィート時に添付する画像をTwitterアカウントで登録することができます。</p>
      <p>アップロードと同時に<a href="https://twitter.com/TohokusanB" target="_blank" rel="noopener noreferrer">@TohokusanB</a>からツィートされます。</p>
    </div>
    <div v-show="user && !preview">
      <p>お手持ちの画像を選択してアップロードしてください。</p>
      <div class="form-group">
        <label for="name">画像ファイル</label>
        <input type="file" accept="image/*" class="form-control" @change="onFileChange" ref="file" />
      </div>
    </div>
    <div class="preview" v-if="user && preview">
      <img :src="preview" alt="" />
      <div>
        <span v-for="(selected, index) in selectedTags" :key="index">
          <SelectTag :tagId="index + 2" :selected="selected" @click="selectTag" />
        </span>
      </div>
      <div>
        <button class="btn btn-cancel btn-secondary" @click.prevent="cancel" type="button">キャンセル</button>
        <button
          class="btn btn-register btn-primary"
          @click.prevent="register"
          type="button"
          :disabled="registerDisabled">登録</button>
      </div>
    </div>
    <div v-if="!user">
      <a class="btn twitter-link" href="/auth/twitter/redirect">
        <i class="fab fa-twitter fa-lg" />
        <span>Twitterアカウントでログイン</span>
      </a>
    </div>
    <div v-show="!preview">
      <hr />
      <Timeline
        id="TohokusanB"
        source-type="profile"
        :options="{ theme: 'dark' }" />
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Timeline } from "vue-tweet-embed";
import SelectTag from "../components/SelectTag.vue";

export default Vue.extend({
  name: "register",
  components: {
    Timeline,
    SelectTag,
  },
  data() {
    return {
      user: undefined,
      success: undefined,
      error: undefined,
      preview: undefined,
      selectedTags: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
      ],
    };
  },
  created() {
    fetch("/api/user").then(res => res.json()).then((user) => {
      this.user = user;
    });
  },
  computed: {
    registerDisabled() {
      return this.selectedTags.indexOf(true) === -1;
    },
  },
  methods: {
    onFileChange(e) {
      this.success = undefined;
      this.error = undefined;
      this.selectedTags = this.selectedTags.map(() => false);
      const files = e.target.files || e.dataTransfer.files;
      const file = files[0];

      const reader = new FileReader();
      reader.onload = (e2) => {
        this.preview = e2.target.result;
      };
      reader.readAsDataURL(file);
    },
    selectTag(tagId) {
      const current = this.selectedTags[tagId - 2];
      console.log("selectTag2", tagId, current);
      this.selectedTags = this.selectedTags.map((v, i) => {
        if (i + 2 === tagId) {
          v = !v;
        }
        return v;
      });
    },
    cancel() {
      this.preview = undefined;
      this.$refs.file.value = "";
    },
    register() {
      const file = this.$refs.file.files.item(0);
      if (!file) {
        return;
      }
      const tags = this.selectedTags.map((v, i) => {
        const result = v ? i + 2 : 0;
        return result;
      }).filter(v => v !== 0).join(",");

      const formData = new FormData();
      formData.append("file", file);
      formData.append("tags", tags);
      fetch("/api/register/upload", {
        method: "POST",
        body: formData,
      }).then(() => {
        this.success = "画像を登録しました";
        this.cancel();
      }).catch((e) => {
        this.error = "画像を登録できませんでした: " + e;
      });
    },
  },
});
</script>

<style scoped lang="scss">
.index-list {
  margin-top: 50px;
  text-align: left;
}
.head_image {
  height: 360px;
  overflow: hidden;
  img {
    position: relative;
    top: -190px;
    width: 100%;
  }
}

.twitter-link {
  display: block;
  width: 320px;
  margin: 24px auto;
  background-color: #55acee;
  height: 50px;
  padding: 3px 30px;
  line-height: 44px;
  color: #fff;
  border-radius: 25px;
  transition: background-color .3s ease-in-out, border-color .3s ease-in-out;
}

.twitter-link:active, .twitter-link:hover, .twitter-link:focus {
  color: #fff;
}

.twitter-link span {
  padding-left: 5px;
}

.preview {
  text-align: center;
  img {
    width: 80%;
  }
}

.btn-cancel, .btn-register {
  width: 120px;
  margin: 10px;
}
</style>
